// extracted by mini-css-extract-plugin
export default {"icon":"NewIcon_icon__R-GD3","pulse":"NewIcon_pulse__2lGdV","shine":"NewIcon_shine__Ygl7N"};